// @flow

import classNames from 'classnames';
import React from 'react';
import styles from './HeroSliderDot.css';
import { injectIntl, defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  ariaLabelHeroSliderDot: {
    id: 'aria-labels-hero-slider-dot',
    defaultMessage: 'Go to slide {index}',
  },
});
type OwnProps = {
  onClick: Function,
  isActive: boolean,
  index: number,
};

type Props = OwnProps & { intl: IntlShape };

const HeroSliderDot = ({ index, isActive, onClick, intl }: Props) => {
  const className = classNames(styles.dot, {
    [styles.isActive]: isActive,
  });
  return (
    <button
      className={className}
      onClick={e => onClick(e, index)}
      aria-label={intl.formatMessage(messages.ariaLabelHeroSliderDot, {
        index: index + 1,
      })}
      aria-disabled={!isActive}
    >
      <div className={styles.dotInner} />
    </button>
  );
};

export default injectIntl(HeroSliderDot);
